import { createFileRoute } from "@tanstack/react-router"
import { HakioSettingsPage } from "~/components/settings/HakioSettingCard"

export const Route = createFileRoute("/_auth/settings/_layout/_internal/hakio")({
  component: HakioSettingsPage,
})
